import type { ChatMessage } from "../Chat/chat";

export type AskVivoLocalState = {
  isNewSession: boolean;
  prompt: string;
  contextPrompt: string;
  oldSessionTimeStamp: string | null;
  firstChat: ChatMessage | null;
  isAHistoryItem: boolean;
};

export const INITIAL_LOCAL_STATE: AskVivoLocalState = {
  isNewSession: true,
  prompt: "",
  contextPrompt: "",
  oldSessionTimeStamp: null,
  firstChat: null,
  isAHistoryItem: false,
};

export type AskVivoLocalAction =
  | { type: "RESET" }
  | { type: "SEARCH_STARTED"; prompt: string; isFirstMessage: boolean }
  | { type: "REGENERATE_STARTED" }
  | {
      type: "CHAT_COMPLETED";
      firstChat: ChatMessage;
      contextPrompt: string;
    }
  | {
      type: "SESSION_LOADED";
      firstChat: ChatMessage;
      contextPrompt: string;
      oldSessionTimeStamp: string;
    }
  | { type: "SESSION_LOAD_FAILED" };

export function askVivoLocalReducer(
  state: AskVivoLocalState,
  action: AskVivoLocalAction,
): AskVivoLocalState {
  switch (action.type) {
    case "RESET":
      return INITIAL_LOCAL_STATE;
    case "SEARCH_STARTED":
      return {
        ...state,
        prompt: action.prompt,
        isNewSession: false,
        firstChat: null,
        contextPrompt: action.isFirstMessage
          ? action.prompt
          : state.contextPrompt,
      };
    case "REGENERATE_STARTED":
      return { ...state, firstChat: null };
    case "CHAT_COMPLETED":
      return {
        ...state,
        firstChat: action.firstChat,
        contextPrompt: action.contextPrompt,
      };
    case "SESSION_LOADED":
      return {
        ...state,
        isNewSession: false,
        firstChat: action.firstChat,
        contextPrompt: action.contextPrompt,
        oldSessionTimeStamp: action.oldSessionTimeStamp,
        isAHistoryItem: true,
      };
    case "SESSION_LOAD_FAILED":
      return { ...state, isAHistoryItem: false };
    default:
      return state;
  }
}
